import React, { useContext, useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { Breadcrumbs, Tabs, Tab, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { init, reset, updateGenerales, save } from './edit-secret-actions';
import { Box, Paper, TextField, Button } from '@mui/material'
import { setLoading } from '../../template/app-actions';
import toast from 'react-hot-toast';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import Header from '../../template/Header';
import AppContext from '../../state/AppContext';
import LocalPoliceIcon from '@mui/icons-material/LocalPolice';
import GrantBreadcrumbs from '../../template/GrantBreadcrumbs';


const EditSecret = (props) => {

    const navitage = useNavigate()
    const { appContext } = useContext(AppContext)
    const project = appContext.project
    const state = useSelector(state => state.pages.editSecret)
    const [tab, setTab] = useState(0)
    let { secret } = useParams()

    useEffect(() => {
        init(project, secret)
        return () => reset()
    }, [secret])

    const changeTab = (event, newValue) => {
        setTab(newValue);
    };

    const _save = async (event) => {
        try {
            event.preventDefault()
            setLoading(true)
            await save(event, project, navitage)
        } catch (error) {
            console.error(error)
            toast.error("Error to perform action")
        } finally {
            setLoading(false)
        }
    }

    return (
        <div className="">
            <Header title={<span className="capitalize" >{state.key}</span>} backLink={`/projects/${project}/secrets`} >
                <Breadcrumbs aria-label="breadcrumb" separator="/" className="!text-gray-600">
                    <Typography ><HomeOutlinedIcon className="text-gray-600" fontSize="small" /></Typography>
                    <GrantBreadcrumbs permisos={[Permissions.SECRETS_W]} text="Secret" link={`/projects/${project}/secrets`} />
                    <Typography ><span className="text-gray-600">{state.key}</span></Typography>
                </Breadcrumbs>
            </Header>
            <div className="content grid gap-8">
                <form onSubmit={_save}>
                    <div className="grid gap-8">
                        <div className=" ">
                            <Box>
                                <Paper>
                                    <Box sx={{ width: '100%' }}>
                                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                            <Tabs value={tab} onChange={changeTab} aria-label="basic tabs example">
                                                <Tab label="Secret" icon={<LocalPoliceIcon />} iconPosition="start" />
                                            </Tabs>
                                        </Box>
                                    </Box>

                                    {tab === 0 && (
                                        <div className="grid grid-cols-2">
                                            <div className="grid gap-4 p-4">
                                                <TextField
                                                    required
                                                    disabled={!state.new}
                                                    size="medium"
                                                    label="key"
                                                    name="key"
                                                    onChange={updateGenerales}
                                                    value={state.key}
                                                />
                                                <TextField
                                                    required
                                                    size="medium"
                                                    label="Value"
                                                    name="value"
                                                    onChange={updateGenerales}
                                                    value={state.value}
                                                />
                                                <TextField
                                                    required
                                                    size="medium"
                                                    label="Description"
                                                    name="description"
                                                    onChange={updateGenerales}
                                                    value={state.description}
                                                />
                                            </div>
                                        </div>
                                    )}
                                    <div className="p-4 text-right bg-gray-100 border-t border-gray-300">
                                        <Button variant="contained" type="submit" className="text-dark-500" >SAVE</Button>
                                    </div>
                                </Paper>
                            </Box>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default EditSecret